import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
const packageJson = require("../../../package.json");

const Footer = () => {
  const currentVersion = packageJson.version;
  const screenWidth = useSelector((state) => state.layout.currentScreenWidth);

  return (
    <div>
      <footer className="footer shadow d-flex align-items-center">
        <div className="container-xxl">
          <div className="row">
            <div className="col-sm-7 col-md-7 col-lg-7 mt-md-0 mt-2">
              <p className={`text-xs mb-0 ${screenWidth < 574 ? "text-center" : "text-left"}`}>
                Developed by {" "}
                <Link to="https://suretytelco.com/" target="_blank">
                  SURETY-TELCO
                </Link>
                {" "} | {" "}
                Sales by {" "}
                <Link to="https://soft-techsolutions.com/" target="_blank">
                  SOFT-TECH SOLUTION
                </Link> {" "}
                Copyrights © 2014 - {new Date().getFullYear()}
                {" "} | {" "}
                All Right Reserved
              </p>
            </div>
            <div className="col-sm-5 col-md-5 col-lg-5 text-sm-end">
              <p className={`text-xs mb-0 ${screenWidth < 574 ? "text-center" : "text-left"}`} style={{ fontSize: "12px" }}>
                Version <span className="fw-bold">{currentVersion}</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
      <div className="content-backdrop fade" />
      <div className="layout-overlay layout-menu-toggle" />
      <div className="drag-target" />
    </div>
  );
};

export default Footer;
